/* istanbul ignore file */
import { Decorator } from './decorator';

function replaceAtom(atom, oldKey, newKey) {
  if (oldKey in atom) {
    const newAtom = {
      ...atom,
      [newKey]: atom[oldKey],
    };
    delete newAtom[oldKey];

    return newAtom;
  }
  return atom;
}

function replaceKeyOfQuery(query, oldKey, newKey) {
  if (!query) return query;
  let finalQuery = { ...query };
  if (oldKey in finalQuery) {
    finalQuery = replaceAtom(finalQuery, oldKey, newKey);
  } else if ('$and' in finalQuery) {
    finalQuery.$and.forEach((value, index, array) => {
      // eslint-disable-next-line no-param-reassign
      array[index] = replaceAtom(value, oldKey, newKey);
    });
  }
  return finalQuery;
}

/**
 * "data exclusion" is a special "SeasonalityAdjustment" edm
 * But when using filter, although we still need to use "SeasonalityAdjustmentId" as query option,
 * user should see "data exclusion id eqaul xxx" rather than "seasonality adjuemsnt id eqaul xxx".
 * Convert the query option when build query to do this.
 */
export class DataExclusionFilterProcessorDecorator extends Decorator {
  constructor({
    featureName,
  }) {
    super({ name: 'data-exclusion-filter-processor' });

    this.featureName = featureName;
  }

  getValueAsync() {
    // eslint-disable-next-line no-restricted-globals
    return Promise.resolve();
  }

  buildQuery(queryParams) {
    const finalWhere = replaceKeyOfQuery(
      queryParams.where,
      'DataExclusionId',
      'SeasonalityAdjustmentId'
    );

    return {
      ...queryParams,
      where: finalWhere,
    };
  }
}
